import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiRdaRifiutateWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'rda-rifiutate-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/purchase-requests/count', {
        params: { stato_nome: 'Rifiutata' },
      })
      return res.data?.count ?? 0
    },
    staleTime: 30000,
  })
  return (
    <KpiWidget
      title="RDA rifiutate"
      value={data}
      loading={isLoading}
      color={data ? '#ff4d4f' : '#52c41a'}
      onClick={() => navigate('/rda?stato_nome=Rifiutata')}
    />
  )
}
